var map = {
	"./398F09_0_0.eot": 53,
	"./398F09_0_0.svg": 54,
	"./398F09_0_0.ttf": 55,
	"./398F09_0_0.woff": 56,
	"./398F09_0_0.woff2": 57,
	"./398F09_0_unhinted_0.ttf": 58,
	"./398F09_0_unhinted_0.woff": 59,
	"./398F09_0_unhinted_0.woff2": 60,
	"./svg_test.html": 61
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;


//////////////////
// WEBPACK FOOTER
// ./src/webfonts ^\.\/.*\.*
// module id = 82
// module chunks = 0